import axios from "../config/axios-chatbot";


export const FlowProjectRepository = {
  updateFlow: ({id, project}) => axios.post(`/api/flow/sub-project/${id}/update`, project),
  updateFlowFromStage: ({id, url, ...params}) => {
    if (url) {
      return axios.post(`${url}/api/flow/${id}/update`, {params: {...(params || {})}})
    }
    return axios.post(`/api/flow/${id}/update`, {params: {...(params || {})}})
  },
  updateProjectFromStage: ({id, url, project}) => {
    if (url) {
      return axios.post(`${url}/api/flow/${id}/update`, project)
    }
    return axios.post(`/api/flow/${id}/update`, project)
  },
}